const saveUser = (user) => localStorage.setItem("user", JSON.stringify(user));

const saveIdToken = (idToken) => localStorage.setItem("idToken", idToken);

const getUser = () => JSON.parse(localStorage.getItem("user"));

const getIdToken = () => localStorage.getItem("idToken");

const saveClient = (client) =>
  localStorage.setItem("client", JSON.stringify(client));

const getClient = () => {
  const raw = localStorage.getItem("client");
  if (!raw) return null;
  return JSON.parse(raw);
};

const idToken = () => localStorage.getItem("idToken");

const clearUserData = () => localStorage.clear();

export {
  saveUser,
  getUser,
  saveClient,
  getClient,
  idToken,
  clearUserData,
  saveIdToken,
  getIdToken,
};
